import { render, staticRenderFns } from "./store-location.vue?vue&type=template&id=49899a60&scoped=true&"
import script from "./store-location.vue?vue&type=script&lang=js&"
export * from "./store-location.vue?vue&type=script&lang=js&"
import style0 from "./store-location.vue?vue&type=style&index=0&id=49899a60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49899a60",
  null
  
)

export default component.exports